<div class="d-flex flex-column gap-4">
  <div class="file-list-label" i18n>Additional Files</div>
  <ng-container *ngIf="files?.length">
    <div class="d-flex flex-column gap-3">
      <app-file-list-item
        class="w-100"
        *ngFor="let file of files"
        [fileName]="file.attachment.fileName"
        [fileSizeInBytes]="file.attachment.fileSize"
        [previewUrl]="file.attachment.links | attachmentLink"
        [action]="getFileAction()"
        [actionDisabled]="isFileActionDisabled()"
        (removeClicked)="removeFile.emit(file)" />
    </div>
    <hr />
  </ng-container>
  <div *ngIf="!files?.length && !canUploadFiles" class="no-files" i18n>No additional files.</div>
  <ng-container *ngIf="canUploadFiles">
    <app-button
      class="d-block"
      [style.width.rem]="9.6"
      [type]="ButtonTypeEnum.secondary"
      (buttonClick)="uploadFile.click()">
      <span class="d-flex gap-2 align-items-center">
        <img [src]="'assets/icons/dark/Attachment.svg'" alt="" [style.width.rem]="1.25" [style.height.rem]="1.25" />
        <span i18n>Upload File</span>
      </span>
    </app-button>
    <input
      #uploadFile
      type="file"
      [accept]="['image/png', 'image/jpeg', 'application/pdf']"
      (change)="fileUploadedEvent($event)"
      hidden />
  </ng-container>
</div>
